module.exports = __webpack_public_path__ + "static/media/all-biding.7b0bc7aa.svg";